import PropTypes from 'prop-types';

export function getPaginatedShape(resourceShape) {
  return PropTypes.shape({
    docs: PropTypes.arrayOf(resourceShape),
    totalDocs: PropTypes.number,
    limit: PropTypes.number,
    hasPrevPage: PropTypes.bool,
    hasNextPage: PropTypes.bool,
    page: PropTypes.number,
    totalPages: PropTypes.number,
    pagingCounter: PropTypes.number,
    prevPage: PropTypes.oneOfType([ PropTypes.bool, PropTypes.number ]),
    nextPage: PropTypes.oneOfType([ PropTypes.bool, PropTypes.number ]),
  });
}

export const CompanyShape = PropTypes.shape({
  deleted: PropTypes.bool,
  _id: PropTypes.string,
  name: PropTypes.string,
  enabled: PropTypes.bool,
  addresses: PropTypes.arrayOf(
    PropTypes.shape({
      city: PropTypes.string,
      state: PropTypes.string,
      address: PropTypes.string,
      zip: PropTypes.string,
    }),
  ),
});

export const CompanyFilterShape = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.string,
  suggestion: CompanyShape,
});

export const UserShape = PropTypes.shape({
  emailNotifications: PropTypes.bool,
  vmailNotifications: PropTypes.bool,
  vmailAttachment: PropTypes.bool,
  vmailDownloadLink: PropTypes.bool,
  boxAccount: PropTypes.bool,
  boxApiKey: PropTypes.string,
  deleted: PropTypes.bool,
  _id: PropTypes.string,
  email: PropTypes.string,
  password: PropTypes.string,
  isAdmin: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  company: CompanyShape,
  registerDate: PropTypes.string,
  enabled: PropTypes.bool,
  role: PropTypes.oneOf(['superAdmin', 'admin', 'user', 'agent', 'quoteToolAdmin','companyGroupAdmin']),
});

export const ProposalShape = PropTypes.shape({
  name: PropTypes.string,
  mrc: PropTypes.number,
  date: PropTypes.string,
  lastEditedBy: UserShape._id,
  deleted: PropTypes.bool,
  user: UserShape._id,
  company: CompanyShape._id,
  status: PropTypes.oneOf(['new', 'edited', 'viewed', 'signed']),
  meta: PropTypes.any,
  uuid: PropTypes.string,
  totalBoxes: PropTypes.number,
  term: PropTypes.string,
});

export const ProposalsPaginatedShape = getPaginatedShape(ProposalShape);
export const UsersPaginatedShape = getPaginatedShape(UserShape);
